import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { requestS3URL } from '../../../services/web-api-client';
import { CloudFrontSigner } from '../../../utils/cloud-front-signer/cloud-front-signer';
import { GLTFTDescriptor } from '../../../viewer/utilities/octTree/octTreeParser';
import { PointCloudStore } from './point-cloud-store';

/**
 *  Signs and downloads point cloud data using CloudFront signed requests.
 */
export class SignedCloudFrontPointCloudStore implements PointCloudStore {
  constructor(
    private pointCloudCloudFrontSigner: CloudFrontSigner,
    private scanId: string,
  ) {}

  /**
   *  Returns the descriptor object from CloudFront using the signed request.
   *
   *  TODO: Descriptor does not exist in the point cloud S3 storage. This is a limit / bug / oversight in the current implementation.
   *  Without support for Lambda@Edge proxy through endpoint path, it is not accessible yet as it recides in another bucket (skymap.gltf).
   *
   *  Either migrate and update point cloud process to make a copy of the descriptor to the point cloud S3 path.
   *  Or integrate descriptor access through gltft scan store (still needs Lambda@edge implemented)
   */
  async fetchDescriptor() {
    const { url } = await SkyMapAxiosServiceFactory.instance
      .createScanServiceV0()
      .getDescriptor({ body: { id: this.scanId } });
    const descriptor = await requestS3URL(url);

    return JSON.parse(descriptor.data) as GLTFTDescriptor;
  }

  /**
   *  Returns the signed CloudFront url for the pcd file path.
   *  @param path - The path for the tile set file.
   */
  async fetchPcdUrl(path: string) {
    return Promise.resolve(this.pointCloudCloudFrontSigner.getSignedRequest(path));
  }
}
